import React, { useContext } from 'react';
import styles from './style.module.css';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import TabletContext from 'context/TabletContext';
import { warning } from 'assets/newIcons';

const CustomTextField = ({
  placeholder,
  onChange,
  value,
  invalid,
  error,
  name,
  onBlur,
  disabled,
  type,
  // rightIcon,
  // onClickIcon,
  marginTop,
}) => {
  const isTablet = useContext(TabletContext);
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : isTablet ? styles.tab : null;
  return (
    <div style={{ marginTop }} className={styles.body}>
      <input
        className={`${styles.input} ${mobClassName} ${
          error && invalid ? styles.err : ''
        }`}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        invalid={invalid}
        error={error}
        name={name}
        onBlur={onBlur}
        disabled={disabled}
        type={type}
      />
      <div
        className={`${styles.errorDiv} ${
          !invalid && !error && !error ? styles.hide : null
        }`}
      >
        {error && invalid ? (
          <img className={styles.warning} alt="" src={warning} />
        ) : null}
        <p className={`${styles.error} ${mobClassName}`}>{invalid && error && error}</p>
      </div>
    </div>
  );
};

CustomTextField.propTypes = {
  placeholder: PropTypes.string,
  rightIcon: PropTypes.string,
  onClickIcon: PropTypes.func,
  onChange: PropTypes.func,
};

CustomTextField.defaultProps = {
  placeholder: '',
};
export default CustomTextField;
